export enum ListModeEnum {
  CARD = 'CARD',
  LIST = 'LIST',
  CUSTOM_LIST = 'CUSTOM_LIST',
}
